"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var create_lesson_plan_html_1 = __importDefault(require("./create-lesson-plan.html"));
var create_lesson_plan_controller_1 = __importDefault(require("./create-lesson-plan.controller"));
var roadmap_resolves_1 = require("../../roadmaps/roadmap-resolves");
function getCourseTypes(CourseTypesModel) {
    return CourseTypesModel.get().then(function (response) {
        return response.courseTypes;
    });
}
getCourseTypes.$inject = ["CourseTypesModel"];
function getSessionTypes(DriveSessionTypesModel) {
    return DriveSessionTypesModel.get().then(function (response) {
        return response.sessionTypes;
    });
}
getSessionTypes.$inject = ["DriveSessionTypesModel"];
function config($stateProvider, $urlRouterProvider) {
    $stateProvider.state("drivecoach.admin.lessonplans.create", {
        url: "/create-workflow",
        controller: "CreateLessonPlanController",
        controllerAs: "vm",
        template: create_lesson_plan_html_1.default,
        resolve: {
            courseTypes: getCourseTypes,
            sessionTypes: getSessionTypes,
            documentTemplates: roadmap_resolves_1.getDocumentTemplates,
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider"];
exports.default = angular_1.default
    .module("drivecoach.admin.lessonplans.create", [])
    .config(config)
    .controller("CreateLessonPlanController", create_lesson_plan_controller_1.default);
